import { render, staticRenderFns } from "./VariablesEmptyView.vue?vue&type=template&id=253f4c4d&"
import script from "./VariablesEmptyView.vue?vue&type=script&lang=js&"
export * from "./VariablesEmptyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports